"use client";

import { SBrandDto } from "@/__generated__/graphql";
import { Checkbox, List, ListItem, ListItemButton, Stack, TextField, Typography } from "@mui/material";
import { useMemo, useState } from "react";

type Props = {
  brands?: SBrandDto[] | null;
  values?: number[];
  onToggle: (id: number) => void;
};

export default function SearchFiltersBrandsSelect(props: Props) {
  const [search, setSearch] = useState("");
  const brands = useMemo(() => {
    const source = [...(props.brands ?? [])].sort((a, b) => a.title.localeCompare(b.title, "fa"));
    const query = search.trim().toLocaleLowerCase("fa");
    if (!query) {
      return source;
    }

    return source.filter(
      (brand) => brand.title.toLocaleLowerCase("fa").includes(query) || brand.title_en.toLocaleLowerCase("en").includes(query),
    );
  }, [props.brands, search]);

  return (
    <>
      <TextField
        label="جستجو در برندها"
        placeholder="نام برند"
        variant="standard"
        fullWidth
        size="small"
        color="info"
        margin="none"
        value={search}
        inputProps={{ maxLength: 40 }}
        onChange={(event) => {
          setSearch(event.target.value.slice(0, 40));
        }}
      />
      <List dense sx={{ width: "100%", maxHeight: 320, overflowY: "auto", bgcolor: "background.paper" }} className="custom-scrollbar">
        {brands.length <= 0 && (
          <Typography variant="caption" sx={{ px: 1 }}>
            برند پیدا نشد
          </Typography>
        )}
        {brands.map((brand) => {
          const selected = Boolean(props.values?.includes(brand.id));
          return (
            <ListItem key={brand.id} disablePadding>
              <ListItemButton
                selected={selected}
                onClick={() => {
                  props.onToggle(brand.id);
                }}
              >
                <Checkbox edge="end" size="small" sx={{ mr: 1, p: 0.2, pointerEvents: "none" }} checked={selected} tabIndex={-1} />
                <Stack sx={{ width: "100%" }} direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                  <Typography variant="body2">{brand.title}</Typography>
                  <Typography variant="caption">{brand.title_en}</Typography>
                </Stack>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}
